import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Overview from './components/Overview';
import Characters from './components/Characters';
import Cast from './components/Cast';
import Relationships from './components/Relationships';
import Storyline from './components/Storyline';
import Highlights from './components/Highlights';
import Faq from './components/Faq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <Overview />
        <Characters />
        <Cast />
        <Relationships />
        <Storyline />
        <Highlights />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}